import { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './styles.css';
import 'react-tabs/style/react-tabs.css';
import api from '../../services/api';

export default function Usuarios({ termoPesquisa }) {
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    const buscarUsuarios = async () => {
      try {
        const response = await api.get('/api/buscarProjetos');
        setUsuarios(response.data);
        console.log(usuarios);
      } catch (error) {
        console.error('Erro ao buscar usuários:', error);
      }
    };
    console.log(termoPesquisa);
    buscarUsuarios();
  }, [termoPesquisa, usuarios]);

  // console.log({ usuarios });

  const usuariosFiltrados = usuarios?.filter((usuario) => {
    const termo = termoPesquisa?.toLowerCase() ?? '';
    return (
      usuario.nome_projeto?.toLowerCase().includes(termo) ||
      usuario.nome_cliente?.toLowerCase().includes(termo)
    );
  });

  console.log(usuariosFiltrados);

  return (
    <div className="w-full">
      <DataTable
        className="custom-data-table"
        value={usuariosFiltrados}
        stripedRows
        style={{
          border: '1px solid #E4E4E7',
          fontWeight: '400',
          color: '#000!important',
          borderWidth: '1px 1px 0px 1px',
        }}
        scrollable
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: '50rem' }}
      >
        <Column field="nome_projeto" header="Nome Projeto"></Column>
      </DataTable>
    </div>
  );
}
